"use client";

import { InformationCircleIcon } from "@hugeicons-pro/core-stroke-rounded";
import ControlIcon from "./ControlIcon";
import { ControlContainer, type ControlProps } from "./IconContainer";

export function GameControlsInfo(props: ControlProps) {
  return (
    <ControlContainer noClickable {...props}>
      <ControlIcon icon={InformationCircleIcon} />
    </ControlContainer>
  );
}
